// firebase.js
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBOJvFdHizPLr_m-MVklgrJ2CxgUKoUSwg",
  authDomain: "simpelabsensi.firebaseapp.com",
  projectId: "simpelabsensi",
  storageBucket: "simpelabsensi.firebasestorage.app",
  messagingSenderId: "243814805882",
  appId: "1:243814805882:web:f9ce31f4551197c19ea6c3",
  measurementId: "G-RBTRPRPKWB"
};
const firebaseApp = initializeApp(firebaseConfig);

export { firebaseApp };
